import React from 'react';
import resume, { EducationEntry } from '../../data/resume';
import styles from './Education.module.css';

interface EducationCardProps {
  entry: EducationEntry;
}

const EducationCard: React.FC<EducationCardProps> = ({ entry }) => (
  <div className={styles.card}>
    <div className={styles.cardLeft}>
      <h3 className={styles.institution}>{entry.institution}</h3>
      <p className={styles.degree}>{entry.degree}</p>
      {entry.concentrations && (
        <div className={styles.concentrations}>
          <span className={styles.concentrationsLabel}>Concentrations:</span>
          {entry.concentrations.map((c, i) => (
            <span key={i} className={styles.concentrationTag}>{c}</span>
          ))}
        </div>
      )}
      <span className={styles.period}>{entry.period}</span>
      <span className={styles.location}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
        {entry.location}
      </span>
    </div>
    <ul className={styles.bullets}>
      {entry.bullets.map((bullet, i) => (
        <li key={i} className={styles.bullet}>
          <span className={styles.bulletDot} />
          {bullet}
        </li>
      ))}
    </ul>
  </div>
);

const Education: React.FC = () => (
  <section id="education" className={styles.section}>
    <div className={styles.inner}>
      <h2 className={styles.sectionTitle}>Education</h2>
      <div className={styles.cards}>
        {resume.education.map((entry, i) => (
          <EducationCard key={i} entry={entry} />
        ))}
      </div>
    </div>
  </section>
);

export default Education;
